import React from 'react';
import PropTypes from 'prop-types';
import styles from './Banner.scss';

const Banner = ({ page }) => {
  return (
    <div className={styles.container}>
      <p>{page}</p>
    </div>
  );
};

Banner.propTypes = {
  page: PropTypes.oneOf(['about', 'features', 'home']).isRequired
};

export default Banner;
